import React, { useContext } from 'react';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';
import { VenueContext } from 'modules/venue/VenueContext';

export type MenuModuleContextProps = {
  venue: Venue;
};

export const MenuModuleContext = React.createContext<MenuModuleContextProps>(
  undefined as unknown as MenuModuleContextProps,
);

export const useMenuModuleContext = (): MenuModuleContextProps => {
  const menuModuleContext = useContext(MenuModuleContext);
  const oldVenue = useContext(VenueContext);
  if (!menuModuleContext) {
    return { venue: oldVenue as Venue };
  }
  return menuModuleContext;
};

export const MenuModuleContextProvider = MenuModuleContext.Provider;
